





















import Vue from "vue";
import { Auth } from "aws-amplify";
import ButtonDefault from "@/components/atoms/ButtonDefault.vue";
import TextField from "@/components/molecules/TextField.vue";
import { showNotifyDialog } from "@/lib/dialog";

export default Vue.extend({
  components: { ButtonDefault, TextField },
  props: {
    username: String
  },
  data() {
    return {
      message: "",
      newPassword: "",
      code: ""
    };
  },
  methods: {
    async submit() {
      const { username, code, newPassword: password } = this;

      try {
        const res = await Auth.forgotPasswordSubmit(username, code, password);
        console.log(res);
        await showNotifyDialog({
          content: "パスワードの再設定が完了しました。"
        });
        this.$router.push({ name: "signIn" });
      } catch (error) {
        if (error.code === "CodeMismatchException") {
          this.message = `確認コードが正しくありません`;
        } else if (error.code === "UsernameExistsException") {
          this.message = `メールアドレスは既に登録済みです`;
        } else if (error.code === "InvalidParameterException" || error.code === "InvalidPasswordException") {
          this.message = `パスワードは7文字以上かつ大文字・小文字を含む文字列にしてください`;
        } else if (error.code === 'LimitExceededException') {
          this.message = "送信回数制限に達しました。しばらくしてから再度やり直してください。";
        } else {
          this.message = `エラーが発生しました: ${error.message}`;
        }
      }
    }
  }
});
